module.exports = __webpack_public_path__ + "img/place-keyword-mobile.7ff00b67.png";